/**
 * A photo on its way to the server (docs/partial/shopping-in-store-spec.md 6.4, 7): scaled down
 * to what a model can read and re-encoded, which drops the EXIF block – including the position
 * where the photo was taken. Where the browser cannot decode the file it is sent as it is.
 */
export const PHOTO_MAX_EDGE = 1600;

export async function preparePhoto(file: Blob, maxEdge = PHOTO_MAX_EDGE): Promise<Blob> {
  if (typeof createImageBitmap !== 'function' || typeof document === 'undefined') return file;
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  } catch {
    return file;
  }
  try {
    const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(bitmap.width * scale));
    canvas.height = Math.max(1, Math.round(bitmap.height * scale));
    const context = canvas.getContext('2d');
    if (!context) return file;
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', 0.85),
    );
    return blob ?? file;
  } finally {
    bitmap.close();
  }
}
